/**
 * Emit hosts for the `contact-sales` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type ContactSalesFormOpenedEventProps } from '@/models/analytics/features/contact-sales';

/**
 * Track contact sales form opened event
 * Fired when a contact sales form is opened
 */
export function trackContactSalesFormOpened(input: ContactSalesFormOpenedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ContactSalesFormOpened,
    props: {
      form_id: input.form_id,
    },
  });
}
